import { render, staticRenderFns } from "./PriceAlertMenu.vue?vue&type=template&id=266ddebe&scoped=true"
import script from "./PriceAlertMenu.vue?vue&type=script&lang=js"
export * from "./PriceAlertMenu.vue?vue&type=script&lang=js"
import style0 from "./PriceAlertMenu.vue?vue&type=style&index=0&id=266ddebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ddebe",
  null
  
)

export default component.exports